import React, { useEffect, useState } from 'react';
import Card, { CardContent } from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

const AdminReportsPage: React.FC = () => {
  const [reports, setReports] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState<'OPEN'|'REVIEWING'|'RESOLVED'|'REJECTED'|'ALL'>('OPEN');

  const load = async () => {
    setLoading(true);
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/reports`, { headers: { Authorization: `Bearer ${token}` }, params: { status } });
    setReports(res.data.reports || []);
    setLoading(false);
  };

  useEffect(()=>{ load(); }, [status]);

  const update = async (id: string, next: string) => {
    const token = localStorage.getItem('accessToken');
    await axios.put(`${API_BASE_URL}/api/reports/${id}/status`, { status: next }, { headers: { Authorization: `Bearer ${token}` } });
    await load();
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Reports</h1>
      <div className="mb-4">
        <select value={status} onChange={(e)=>setStatus(e.target.value as any)} className="px-3 py-2 border rounded">
          {['OPEN','REVIEWING','RESOLVED','REJECTED','ALL'].map(s=> <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
      <Card>
        <CardContent>
          {loading ? 'Loading…' : reports.length === 0 ? 'No reports.' : (
            <div className="space-y-3">
              {reports.map((r:any)=> (
                <div key={r.id} className="p-4 border rounded-lg flex items-center justify-between">
                  <div>
                    <div className="text-sm text-gray-600">{r.targetType} • {r.targetId}</div>
                    <div className="font-medium text-gray-900">{r.reason}</div>
                    {r.details && <div className="text-sm text-gray-600">{r.details}</div>}
                  </div>
                  <div className="space-x-2">
                    <Button size="sm" variant="outline" onClick={()=>update(r.id, 'REVIEWING')}>Review</Button>
                    <Button size="sm" onClick={()=>update(r.id, 'RESOLVED')}>Resolve</Button>
                    <Button size="sm" variant="danger" onClick={()=>update(r.id, 'REJECTED')}>Reject</Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminReportsPage;



